import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

type Props = {
  type: string;
  name: string;
  count?: number;
};

const StyledLink = styled(Link)`
  font-size: 0.8rem;
  color: #535353;
  padding: 0.15rem 0.3rem;
  white-space: nowrap;
  text-decoration: none;

  &::before {
    content: '#';
    font-size: 1.4em;
    text-decoration: none;
    display: inline-block;
    margin-right: 0.1rem;
    vertical-align: -0.105em;
  }
  &:hover {
    text-decoration: underline;
  }
`;

export const Tag: React.VFC<Props> = ({ type, name, count }) => (
  <StyledLink to={`/${type}s/tags/${name}`}>
    {name}
    {count && ` (${count})`}
  </StyledLink>
);
